var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-loader",attrs:{"id":'circle-' + _vm.id}},[_c('div',{staticClass:"checkmark draw",attrs:{"id":'checkmark-' + _vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }